import { PointsToCashForMortgageNavigation } from './navigation'
import { PointsToCashForMortgageScreens } from './screens'

export const PointsToCashForMortgage = {
  Screens: PointsToCashForMortgageScreens,
  Navigation: PointsToCashForMortgageNavigation,
  Icons: {},
}
